/**
 * Turns off mustache interpolation for in-DOM templates.
 *
 * `app.mount('#app')` makes Vue take the server-rendered `#app` body as the root
 * template, so any escaped user-controlled string in a text node used to be a
 * live Vue expression: an email address containing `{{ 7*7 }}` rendered as `49`.
 * ERB escapes `< > & " '` but not `{` `}`, and there is no CSP, so the runtime
 * compiler's `new Function` runs unrestricted.
 *
 * `<{` and `}>` cannot be produced by escaped user data: reading `innerHTML`
 * re-escapes `<` to `&lt;` in text nodes per the HTML fragment serialization
 * algorithm, so no input reproduces the delimiter. Directives such as `v-text`
 * and `v-bind` keep working, and `.vue` templates are unaffected because
 * vue-loader precompiles them at build time with the default delimiters.
 *
 * @param {Object} app the Vue application instance to harden
 */
export function hardenInDomTemplates(app) {
  app.config.compilerOptions.delimiters = ['<{', '}>'];
}
